import { useEffect, useState } from "react";
import {
  librariesList,
  librarySeatAdd,
  librarySeatDelete,
  librarySeatsList,
  librarySeatUpdate,
} from "../../api/Library";
import { closeModal, LoadingDiv, SweetAlertShow } from "../master/Master";
import Header from "../master/SideBar";
import Nav from "../master/NavBar";
import usePrivateLink from "../config/usePrivateLink";
import Swal from "sweetalert2";
import Pagination from "../components/Pagination";
import LibraryLayout from "./LibraryLayout";

export default function LibrarySeats() {
  const hasAccess = usePrivateLink();
  const [loading, setLoading] = useState(false);
  const [seats, setSeats] = useState([]);
  const [libraries, setLibraries] = useState([]);
  const [modalData, setModalData] = useState({});
  const [filters, setFilters] = useState([]);

  const getLibraryList = async () => {
    setLoading(true);
    try {
      const response = await librariesList();
      if (response.data?.status) {
        setLibraries(response?.data?.data);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  const getSeatsList = async () => {
    setLoading(true);
    let addUrl = "";
    Object.keys(filters).forEach((key) => {
      const value = filters[key];
      if (value) {
        addUrl += `&${key}=${encodeURIComponent(value)}`;
      }
    });
    try {
      const response = await librarySeatsList(addUrl);
      if (response.data?.status) {
        setSeats(response?.data?.data);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getLibraryList();
  }, []);

  useEffect(() => {
    getSeatsList();
  }, [filters]);

  const createSeats = async (e) => {
    setLoading(true);
    e.preventDefault();
    try {
      const formData = new FormData(e.target);
      const response = await librarySeatAdd(formData);
      if (response?.data?.status) {
        closeModal("addNewSeat");
        SweetAlertShow("success", "Successfully", response?.data?.message);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message,
      );
    } finally {
      setLoading(false);
      getSeatsList();
    }
  };

  const updateSeats = async (e) => {
    setLoading(true);
    e.preventDefault();

    try {
      const formData = new FormData(e.target);
      const response = await librarySeatUpdate(formData);
      if (response?.data?.status) {
        closeModal("editSeat");
        SweetAlertShow("success", "Successfully", response?.data?.message);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message,
      );
    } finally {
      setLoading(false);
      getSeatsList();
    }
  };

  const deleteSeat = async (id) => {
    setLoading(true);
    try {
      const response = await librarySeatDelete(id);
      if (response?.data?.status) {
        SweetAlertShow("success", "Successfully", response?.data?.message);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message,
      );
    } finally {
      setLoading(false);
      getSeatsList();
    }
  };

  return (
    <>
      {loading && <LoadingDiv />}
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />
          <div className="layout-page">
            <Nav />
            <div className="content-wrapper">
              <div className="container-xxl flex-grow-1 container-p-y">
                <div className="row">
                  <LibraryLayout />
                  <div className="col-12">
                    <div className="card my-3">
                      <div className="card-body">
                        <div className="d-flex justify-content-between align-items-center mb-4 border-bottom pb-2">
                          <h4 className="text-primary mb-0">Seats</h4>
                          <div className="d-flex gap-2">
                            {hasAccess("/library/seat/add") && (
                              <button
                                className="btn btn-label-primary btn-sm"
                                data-bs-toggle="modal"
                                data-bs-target="#addNewSeat"
                              >
                                + Add Seat
                              </button>
                            )}
                          </div>
                        </div>
                        <div className="row align-items-center">
                          <div className="col-md-3 col-sm-6 mb-3">
                            <div className="form-floating form-floating-outline">
                              <select
                                name="library_id"
                                id="library_id"
                                className="form-select"
                                value={filters?.library_id}
                                onChange={(e) =>
                                  setFilters({
                                    ...filters,
                                    library_id: e.target.value,
                                  })
                                }
                              >
                                <option value="">All</option>
                                {libraries?.map((library, i) => (
                                  <option key={i} value={library?.id}>
                                    {library?.name}
                                  </option>
                                ))}
                              </select>
                              <label htmlFor="">Select Library</label>
                            </div>
                          </div>
                          <div className="col-md-3 col-sm-6 mb-3">
                            <div className="form-floating form-floating-outline">
                              <input
                                type="text"
                                className="form-control"
                                name="search"
                                placeholder="Search"
                                value={filters?.search}
                                onChange={(e) =>
                                  setFilters({
                                    ...filters,
                                    search: e.target.value,
                                  })
                                }
                              />
                              <label htmlFor="">Search </label>
                            </div>
                          </div>
                          <div className="col-md-2 ">
                            <button
                              type="button"
                              onClick={() => {
                                setFilters({ page: 1 });
                              }}
                              className="btn btn-sm btn-label-danger"
                            >
                              <i className="ri ri-restart-line"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="card my-3">
                      <div className="card-body">
                        <div className="table-responsive">
                          <table className="table">
                            <thead>
                              <tr className="text-nowrap">
                                <th>#</th>
                                <th>Library</th>
                                <th>Seat No</th>
                                {/* <th>Status</th> */}
                                <th>Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              {seats?.data?.map((seat, i) => (
                                <tr key={seat?.id}>
                                  <td>{i + 1}</td>
                                  <td>{seat?.library?.name}</td>
                                  <td>{seat?.seat_no}</td>

                                  <td>
                                    {hasAccess("/library/seat/update") && (
                                      <button
                                        onClick={() => {
                                          setModalData(seat);
                                        }}
                                        className="btn btn-label-info btn-sm me-2"
                                        data-bs-toggle="modal"
                                        data-bs-target="#editSeat"
                                      >
                                        <i className="bi bi-pencil-square"></i>{" "}
                                      </button>
                                    )}
                                    {hasAccess("/library/seat/delete") && (
                                      <button
                                        className="btn btn-label-danger btn-sm me-2"
                                        onClick={() =>
                                          Swal.fire({
                                            title: "Are you sure?",
                                            text: "This action will permanently delete !",
                                            icon: "warning",
                                            showCancelButton: true,
                                            confirmButtonColor: "#d33",
                                            cancelButtonColor: "#6c757d",
                                            confirmButtonText:
                                              "Yes, delete it!",
                                            cancelButtonText: "Cancel",
                                          }).then(async (result) => {
                                            if (result.isConfirmed) {
                                              deleteSeat(seat?.id);
                                            }
                                          })
                                        }
                                      >
                                        <i className="bi bi-trash-fill"></i>{" "}
                                      </button>
                                    )}
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                          <Pagination
                            data={seats}
                            setFilters={setFilters}
                            filters={filters}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="editSeat"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <form onSubmit={updateSeats}>
              <div className="modal-header bg-label-primary p-3">
                <h3 className="modal-title fs-5" id="exampleModalLabel">
                  Edit Library Seat
                </h3>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                />
              </div>
              <div className="modal-body">
                <div className=" p-3">
                  <input type="hidden" name="id" value={modalData?.id} />
                  <div className="form-floating form-floating-outline">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Seat no"
                      name="seat_no"
                      defaultValue={modalData?.seat_no}
                      required
                    />
                    <label className="">Seat no</label>
                  </div>
                </div>
              </div>
              <div className="modal-footer bg-label-primary py-3">
                <button
                  type="submit"
                  className="btn btn-primary px-5"
                  disabled={loading}
                >
                  {loading ? (
                    <span
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                      aria-hidden="true"
                    ></span>
                  ) : (
                    "Submit"
                  )}
                  {loading ? " Submitting..." : ""}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="addNewSeat"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <form onSubmit={createSeats}>
              <div className="modal-header bg-label-primary py-3">
                <h1
                  className="modal-title fs-5"
                  id="exampleModalLabel bg-label-primary"
                >
                  Add Seat
                </h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                />
              </div>
              <div className="modal-body">
                <div className="form-floating form-floating-outline mb-3">
                  <select name="library_id" className="form-control">
                    <option value="" selected disabled>
                      Select Library
                    </option>
                    {libraries?.map((library) => (
                      <option key={library?.id} value={library?.id}>
                        {library?.name}
                      </option>
                    ))}
                  </select>
                  <label className="">Library</label>
                </div>
                <div className="form-floating form-floating-outline mb-3">
                  <input
                    type="number"
                    defaultValue={1}
                    className="form-control"
                    placeholder="Seats"
                    name="seats"
                  />
                  <label className="">Seats</label>
                </div>
              </div>
              <div className="modal-footer  bg-label-primary py-3">
                <button
                  type="submit"
                  className="btn btn-primary px-5"
                  disabled={loading}
                >
                  {loading ? (
                    <span
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                      aria-hidden="true"
                    ></span>
                  ) : (
                    "Submit"
                  )}
                  {loading ? " Submitting..." : ""}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}
